// import { Chip } from '@mui/material';
// import Stack from '@mui/material/Stack';
// import React, { useRef } from 'react';
// import PropTypes from 'prop-types';

// import deleteIcon from '../../../assets/icons/Close.png';

// function InputTags(props) {
//   const inputFile = useRef(null);

//   const handleDelete = (e) => {
//     props?.addData(props?.name, props?.value.filter((chip, key) => key !== e), 13);
//   };

//   const onButtonClick = () => {
//     inputFile.current.focus();
//   };

//   const onchange = (e) => {
//     if (e.target.value !== '') {
//       props?.addData(e.target.name, e.target.value, e.keyCode);
//       if (e.keyCode === 13) {
//         e.target.value = '';
//       }
//     }
//   };

//   return (
//     <div className="input-black">
//       <label className="label" htmlFor={props?.label}>
//         {props?.label} {props?.required && <span className="text-danger">*</span>}
//       </label>
//       <div
//         name={props?.name}
//         role="presentation"
//         className={props?.error ? 'input-box input-box-error' : 'input-box'}
//         onClick={onButtonClick}
//       >
//         <Stack
//           spacing={2}
//           direction="row"
//           useFlexGap
//           flexWrap="wrap"
//         >
//           {
//             props?.value.map((e, index) => (
//               <Chip
//                 style={{
//                   border: '0.75px solid #D0D5DD', background: '#F9FAFB',
//                 }}
//                 label={e}
//                 onClick={() => { }}
//                 onDelete={() => handleDelete(index)}
//                 deleteIcon={<img src={deleteIcon} alt="delete_image_icon" style={{ width: 16, height: 16 }} />}
//               />
//             ))
//           }
//           <input
//             name={props?.name}
//             placeholder={props?.placeholder}
//             className="input-hide"
//             ref={inputFile}
//             autoComplete="off"
//             onKeyUp={onchange}
//             readOnly={props?.readonly}
//           />
//         </Stack>
//       </div>
//       {props?.error && <p className="error-message">{props?.errorMessage}</p>}
//     </div>
//   );
// }

// InputTags.propTypes = {
//   addData: PropTypes.func.isRequired,
//   label: PropTypes.string,
//   required: PropTypes.bool.isRequired,
//   readonly: PropTypes.bool,
//   name: PropTypes.string.isRequired,
//   value: PropTypes.string,
//   placeholder: PropTypes.string,
//   error: PropTypes.bool,
//   errorMessage: PropTypes.string,
// };
// InputTags.defaultProps = {
//   value: '',
//   label: '',
//   placeholder: '',
//   readonly: false,
//   error: false,
//   errorMessage: '',
// };

// export default InputTags;

// 2  Used tags
// import { Chip, Button } from '@mui/material';
// import Stack from '@mui/material/Stack';
// import React, { useRef } from 'react';
// import PropTypes from 'prop-types';

// import deleteIcon from '../../../assets/icons/close-error.png';

// function InputTags(props) {
//   const inputFile = useRef(null);

//   const handleDelete = (e) => {
//     props?.addData(props?.name, props?.value.filter((chip, key) => key !== e), 13);
//   };

//   const onButtonClick = () => {
//     inputFile.current.focus();
//   };

//   const onchange = (e) => {
//     if (e.target.value !== '') {
//       props?.addData(e.target.name, e.target.value, e.keyCode);
//       if (e.keyCode === 13) {
//         e.target.value = '';
//       }
//     }
//   };

//   // Function to handle adding tags from Used Tags buttons
//   const handleUsedTagClick = (tag) => {
//     const valueArray = Array.isArray(props?.value) ? props?.value : []; // Ensure it's an array
//     if (!valueArray.includes(tag) && valueArray.length < 5) {
//       props?.addData(props?.name, [...valueArray, tag], 13);
//     }
//   };

//   return (
//     <div className="input-black">
//       <label className="label" htmlFor={props?.label}>
//         {props?.label} {props?.required && <span className="text-danger">*</span>}
//       </label>
//       <div
//         name={props?.name}
//         role="presentation"
//         className={props?.error ? 'input-box input-box-error' : 'input-box'}
//         onClick={onButtonClick}
//       >
//         <Stack spacing={2} direction="row" useFlexGap flexWrap="wrap">
//           {props?.value.map((e, index) => (
//             <Chip
//               // key={index}
//               style={{
//                 border: '0.75px solid #D0D5DD',
//                 background: '#F9FAFB',
//               }}
//               label={e}
//               onDelete={() => handleDelete(index)}
//               deleteIcon={<img src={deleteIcon} alt="delete_image_icon" style={{ width: 16, height: 16 }} />}
//             />
//           ))}
//           <input
//             name={props?.name}
//             placeholder={props?.placeholder}
//             className="input-hide"
//             ref={inputFile}
//             autoComplete="off"
//             onKeyUp={onchange}
//             readOnly={props?.readonly}
//           />
//         </Stack>
//       </div>
//       {props?.error && <p className="error-message">{props?.errorMessage}</p>}

//       {/* Used Tags Section */}
//       <div>
//         <p>Used Tags:</p>
//         {props?.usedTags.map((tag) => (
//           <Button
//             // key={index}
//             variant="outlined"
//             size="small"
//             style={{ marginRight: '5px', marginBottom: '5px' }}
//             onClick={() => handleUsedTagClick(tag)}
//           >
//             + {tag}
//           </Button>
//         ))}
//       </div>
//     </div>
//   );
// }

// InputTags.propTypes = {
//   addData: PropTypes.func.isRequired,
//   label: PropTypes.string,
//   required: PropTypes.bool.isRequired,
//   readonly: PropTypes.bool,
//   name: PropTypes.string.isRequired,
//   value: PropTypes.arrayOf(PropTypes.string),
//   placeholder: PropTypes.string,
//   error: PropTypes.bool,
//   errorMessage: PropTypes.string,
//   usedTags: PropTypes.arrayOf(PropTypes.string), // New prop for predefined tags
// };

// InputTags.defaultProps = {
//   value: [],
//   label: '',
//   placeholder: '',
//   readonly: false,
//   error: false,
//   errorMessage: '',
//   usedTags: [], // Default empty array
// };

// export default InputTags;

// 3 used tags add functionality
import { useDispatch } from 'react-redux';
import { Chip, Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import deleteIcon from '../../../assets/icons/close-icon.png';
import { setErrorNotification } from '../../../redux/slices/NotificationSlice';

function InputTags(props) {
  const inputFile = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // Function to delete a tag
  const handleDelete = (index) => {
    const updatedTags = props?.value?.filter((_, key) => key !== index);
    props?.addData(props?.name, updatedTags, 13);
  };

  // Function to handle manual input (when pressing Enter key)
  const handleKeyUp = (e) => {
    if (e.keyCode === 13 && e.target.value.trim() !== '') {
      const newTag = e.target.value.trim();
      const valueArray = Array?.isArray(props?.value) ? props?.value : [];

      // Check if the tag already exists or exceeds the limit
      if (!valueArray.includes(newTag) && valueArray.length < 5) {
        props?.addData(props?.name, [...valueArray, newTag], 13);
      } else if (valueArray.includes(newTag)) {
        dispatch(setErrorNotification({ message: 'Tag already exist' }));
      } else {
        dispatch(setErrorNotification({ message: 'Maximum 5 tags allowed' }));
      }
      e.target.value = ''; // Clear input field after adding
    }
  };

  // Function to handle clicking "Used Tags" buttons
  const handleUsedTagClick = (tag) => {
    const valueArray = Array.isArray(props?.value) ? props?.value : [];
    if (!valueArray.includes(tag) && valueArray.length < 5) {
      props?.addData(props?.name, [...valueArray, tag], 13);
    }
  };
  return (
    <div className="input-black input-tag">
      <label className="label" htmlFor={props?.label}>
        {props?.label} {props?.required && <span className="text-danger">*</span>}
      </label>
      <div
        name={props?.name}
        role="presentation"
        className={props?.error ? 'input-box input-box-error' : 'input-box'}
        onClick={() => inputFile.current && inputFile.current.focus()}
      >
        <Stack spacing={1} direction="row" height="100%" useFlexGap flexWrap="wrap">
          {props?.value.map((tag, index) => (
            <Chip
              style={{
                border: '0.75px solid #D0D5DD',
                background: '#F9FAFB',
                margin: '3px',
              }}
              label={tag}
              onDelete={() => handleDelete(index)}
              deleteIcon={<img src={deleteIcon} alt="delete" style={{ width: 16, height: 16 }} />}
            />
          ))}
          {props?.value.length < 5 && (
            <input
              name={props?.name}
              placeholder={props?.placeholder}
              className="input-hide"
              ref={inputFile}
              autoComplete="off"
              onKeyUp={handleKeyUp}
              readOnly={props?.readonly}
            />
          )}
        </Stack>
      </div>
      {props?.error && <p className="error-message">{props?.errorMessage}</p>}

      {/* Used Tags Section */}
      {props?.usedTags.length > 0 && (
        <div style={{ display: 'flex', gap: '10px' }}>
          <p>{t('Used Tags:')}</p>
          {props?.usedTags.slice(0, 3).map((tag) => (
            <Button
              key={tag} // Use the tag itself as the unique key
              variant="outlined"
              size="small"
              style={{
                marginRight: '5px',
                marginBottom: '5px',
                color: '#667185',
                border: '1px solid #E4E7EC',
              }}
              onClick={() => handleUsedTagClick(tag)}
            >
              + {tag}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}

InputTags.propTypes = {
  addData: PropTypes.func.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool.isRequired,
  readonly: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  usedTags: PropTypes.arrayOf(PropTypes.string),
};

InputTags.defaultProps = {
  value: [],
  label: '',
  placeholder: '',
  readonly: false,
  error: false,
  errorMessage: '',
  usedTags: [],
};

export default InputTags;
